import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminJournal() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/journal").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this post?")) return;
    try {
      await api.delete(`/admin/journal/${id}`);
      toast.success("Deleted");
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div data-testid="admin-journal">
      <div className="flex items-center justify-between mb-10">
        <div>
          <p className="eyebrow mb-3">Writing</p>
          <h1 className="font-serif text-5xl font-light">Journal</h1>
        </div>
        <Link to="/admin/journal/new" className="btn-ink" data-testid="new-journal-button">+ New post</Link>
      </div>

      {loading ? <p className="eyebrow text-muted-foreground">Loading…</p> : posts.length === 0 ? (
        <div className="py-20 text-center">
          <h3 className="font-serif text-3xl italic font-light mb-4">No journal posts yet.</h3>
          <Link to="/admin/journal/new" className="btn-ink mt-4 inline-block">Write the first one</Link>
        </div>
      ) : (
        <div className="border-t border-border">
          {posts.map((p) => (
            <div key={p.id} className="grid grid-cols-12 gap-4 items-center py-5 border-b border-border">
              <div className="col-span-2 eyebrow text-muted-foreground">{new Date(p.created_at).toLocaleDateString()}</div>
              <div className="col-span-7">
                <p className="font-serif text-xl">{p.title}</p>
                <p className="text-xs text-muted-foreground line-clamp-1">{p.excerpt}</p>
              </div>
              <div className="col-span-1 eyebrow text-muted-foreground">{p.published ? "Live" : "Draft"}</div>
              <div className="col-span-2 flex gap-4 justify-end text-sm">
                <Link to={`/admin/journal/${p.id}`} className="hair-link">Edit</Link>
                <button onClick={() => del(p.id)} className="hair-link text-destructive">Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
